// @ts-strict-ignore
import { Component, Input } from '@angular/core';
import { LabelIconData } from './label-icon.component.types';
import { IconComponent } from '../icon/icon.component';
import { TooltipDirective } from '../tooltip/tooltip.directive';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-label-icon',
    templateUrl: './label-icon.component.html',
    imports: [CommonModule, IconComponent, TooltipDirective]
})
export class LabelIconComponent {
  @Input() data: LabelIconData;
}
